

import { Badge } from '@/components/ui/badge';

export function SubscriptionHeader() {
  return (
    <div className="text-center mb-12">
      <Badge variant="secondary" className="mb-4 bg-green-100 text-green-800">
        Premium Features
      </Badge>
      <h1 className="text-4xl font-bold mb-4">
        Upgrade Your Training
      </h1>
      <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
        Access advanced analytics, personalized insights, and exclusive features to take your BJJ journey to the next level.
      </p>
    </div>
  );
}
